<template>
  <div>
    <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" padding="auto">
      <v-tooltip />
      <v-axis />
      <v-line position="year*value" />
      <v-point position="year*value" shape="circle" />
    </v-chart>
  </div>
</template>

<script>
import miment from 'miment'
import { setInterval } from 'timers';

const data = [
  { year: '14:00:00', value: 24 },
  { year: '14:00:10', value: 24.5 },
  { year: '14:00:20', value: 26.5 },
  { year: '14:00:30', value: 26 },
  { year: '14:00:40', value: 25.5 },
  { year: '14:00:50', value: 25 },
  { year: '14:01:00', value: 24 },
  { year: '14:01:10', value: 26 }
];

const scale = [{
  dataKey: 'value',
  min: 18,
},{
  dataKey: 'year',
  min: 0,
  max: 1,
}];

export default {
  data() {
    return {
      data,
      scale,
      height: 200,
      now: null
    };
  },
  methods: {
    fetchData() {
      this.data.push({
        year: this.now.add(10, 'ss').format('hh:mm:ss'),
        value: this.random(18, 28).toFixed(1)
      })
      this.data.shift()
    },
    random(min, max) {
      return Math.random() * (max - min) + min
    }
  },
  created() {
    this.now = miment()
    //console.log(this.now)
    const data = []

    const ss = parseInt(parseInt(this.now.format('ss')) / 10) * 10
    this.now.set(ss, 'ss')
    //console.log(this.now)
    for (var i = 0; i< 8; i++) {
      data.push({
        year: miment(this.now).sub(10*(8-i), 'ss').format('hh:mm:ss'),
        value: this.random(18, 28).toFixed(1)
      })
    }
    //console.log(data)
    this.data = data.slice()
    setInterval(this.fetchData, 10000)
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/home/charts/chart-temperature.vue